import dayjs from "dayjs";
import React from "react";

interface IHolidayButtonProps {
  holiday: {
    date: Date;
    name: string;
  };
  selectedDates: Date[];
  onClick: (startDate: Date) => void;
}

export const HolidayButton = ({
  holiday,
  selectedDates,
  onClick,
}: IHolidayButtonProps) => {
  if (selectedDates.some((date) => dayjs(date).isSame(holiday.date, "day"))) {
    return null;
  }

  const handleOnClick = () => {
    onClick(holiday.date);
  };

  return (
    <button
      key={`${holiday.date}-${holiday.name}`}
      type="button"
      className="btn btn-border"
      onClick={handleOnClick}
    >
      <span>{holiday.date.toLocaleDateString()}</span>
      <span>{holiday.name}</span>
    </button>
  );
};
